<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="toc">
<p class="ctfm"><a class="page" id="page.v"></a>CONTENTS</p>
<p class="tocfm"><a class="xref" href="#/eernicnt66ro0005#PRE1" id="rPRE1">Editor’s Preface</a></p>
<p class="tocfm"><a class="xref" href="#/eernicnt66ro0006#PRE2" id="rPRE2">Author’s Preface</a></p>
<p class="tocfm"><a class="xref" href="#/eernicnt66ro0007#ABBR" id="rABBR">Abbreviations</a></p>
<p class="tocfm"><a class="xref" href="#/eernicnt66ro0008#BIBLIO" id="rBIBLIO">Bibliography</a></p>
<p class="tocpt"><a class="xref" href="#/eernicnt66ro0009#INTRO" id="rINTRO">INTRODUCTION</a></p>
<p class="toc"><a class="xref" href="#/eernicnt66ro0009#INTRO.1" id="rINTRO.1">I. General Circumstances</a></p>
<p class="toc"><a class="xref" href="#/eernicnt66ro0009#INTRO.2" id="rINTRO.2">II. Integrity, Literary History, and Text</a></p>
<p class="toc"><a class="xref" href="#/eernicnt66ro0009#INTRO.3" id="rINTRO.3">III. Audience</a></p>
<p class="toc"><a class="xref" href="#/eernicnt66ro0009#INTRO.4" id="rINTRO.4">IV. Nature and Genre</a></p>
<p class="toc"><a class="xref" href="#/eernicnt66ro0009#INTRO.5" id="rINTRO.5">V. Purpose</a></p>
<p class="toc"><a class="xref" href="#/eernicnt66ro0009#INTRO.6" id="rINTRO.6">VI. Theme</a></p>
<p class="toc"><a class="xref" href="#/eernicnt66ro0009#INTRO.7" id="rINTRO.7">VII. Text and Translation</a></p>
<p class="toc"><a class="xref" href="#/eernicnt66ro0009#INTRO.8" id="rINTRO.8">VIII. Structure</a></p>
<p class="toc"><a class="xref" href="#/eernicnt66ro0009#INTRO.9" id="rINTRO.9">IX. Analysis of Romans</a></p>
<p class="tocpt"><a class="xref" href="#/eernicnt66ro0011#pt01" id="rpt01">TEXT, EXPOSITION, AND NOTES</a></p>
<p class="toc"><a class="xref" href="#/eernicnt66ro0011#BODY1" id="rBODY1">I. The Letter Opening (1:1–17)</a></p>
<p class="toc"><a class="xref" href="#/eernicnt66ro0011#BODY3" id="rBODY3">II. The Heart of the Gospel: Justification by Faith (1:18–4:25)</a></p>
<p class="toc"><a class="xref" href="#/eernicnt66ro0011b#BODY5" id="rBODY5">III. The Assurance Provided by the Gospel: The Hope of Salvation (5:1–8:39)</a></p>
<p class="toc"><span class="xref" href="#/eernicnt66ro0011e#BODY7" id="rBODY7" title="Link target outside of Sample"><span class="page" id="page.vi"></span>IV. The Defense of the Gospel: The Problem of Israel (9:1–11:36)</span></p>
<p class="toc"><span class="xref" href="#/eernicnt66ro0011g#BODY8" id="rBODY8" title="Link target outside of Sample">V. The Transforming Power of the Gospel: Christian Conduct (12:1–15:13)</span></p>
<p class="toc"><span class="xref" href="#/eernicnt66ro0011h#BODY9" id="rBODY9" title="Link target outside of Sample">VI. The Letter Closing (15:14–16:27)</span></p>
<p class="tocbm"><span class="xref" href="#/eernicnt66ro0012#notes" id="rnotes" title="Link target outside of Sample">Notes</span></p>
<p class="tocpt">INDEXES</p>
<p class="toc"><span class="xref" href="#/eernicnt66ro0018#INDEX1" id="rINDEX1" title="Link target outside of Sample">I. Subjects</span></p>
<p class="toc"><span class="xref" href="#/eernicnt66ro0019#INDEX2" id="rINDEX2" title="Link target outside of Sample">II. Authors</span></p>
<p class="toc"><span class="xref" href="#/eernicnt66ro0020#INDEX3" id="rINDEX3" title="Link target outside of Sample">III. Scripture References</span></p>
<p class="toc"><span class="xref" href="#/eernicnt66ro0021#INDEX4" id="rINDEX4" title="Link target outside of Sample">IV. Early Extrabiblical Literature</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eernicnt66ro0004.vue?2846169a